<template>
  <v-card class="step-tab-panel" flat>
    <div class="assortment-table h-100 d-flex flex-column">
      <ProductModellingMain />

      <UnsavedDataModal
        ref="unsavedDataModal"
        :value="isUnsavedDataModalOpen"
        @cancel="closeUnsavedDataModal"
        @confirm="confirmUnsavedDataModal"
      />
    </div>
  </v-card>
</template>

<script setup>
import { ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { useUnsavedDataWarning } from '@/composables/unsaved-data-warning';

const { isUnsavedDataModalOpen, closeUnsavedDataModal, confirmUnsavedDataModal, beforeRouteLeave } =
  useUnsavedDataWarning();
const unsavedDataModal = ref(null);

onBeforeRouteLeave((to, from, next) => {
  beforeRouteLeave(to, from, next);
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
</style>
